/**
 * @file キャンペーンコードに関するストア
 */

import { defineStore } from 'pinia'

const LOCAL_STORAGE_KEY = 'code'

export const useCodeStore = defineStore({
  id: 'code',

  state: () => ({
    /**
     * 現在適用されているキャンペーンコード
     *
     * キャンペーンコードは4桁の数値の文字列です。
     *
     * e.g. `7777`
     *
     * **⚠ LocalStorageと同期するために、直接変更しないでください。**
     * `set()`や`clear()`を介して変更してください。
     */
    code: null as string | null,
    /**
     * code2
     *
     * **⚠ LocalStorageと同期するために、直接変更しないでください。**
     * `set()`や`clear()`を介して変更してください。
     */
    code2: null as string | null,
  }),

  getters: {
    query(state) {
      return {
        code: state.code ?? undefined,
        code2: state.code2 ?? undefined,
      }
    },
  },

  actions: {
    /**
     * 初期化する
     *
     * 最初に実行するようにしてください。
     *
     * 1. LocalStorageからデータを取得
     * 2. データをストアへ保持
     */
    init() {
      try {
        // LocalStorageからデータを取得。空ならエラーでcatch節へ
        const data = localStorage.getItem(LOCAL_STORAGE_KEY)
        if (!data) throw null

        // データをパース。パース失敗ならエラーでcatch節へ
        const parsed = JSON.parse(data)

        // 文字列に限定してストアへ保持
        typeof parsed.code === 'string' && (this.code = parsed.code)
        typeof parsed.code2 === 'string' && (this.code2 = parsed.code)
      } catch {
        // 何らかのエラーの場合は、LocalStorageに初期化済みのデータを格納する
        this.store()
      }
    },

    /** 現在のフォームのデータをLocalStorageへ保存する */
    store() {
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ code: this.code, code2: this.code2 }))
    },

    /** キャンペーンコードを空にする */
    clear() {
      this.code = null
      this.code2 = null
      localStorage.removeItem(LOCAL_STORAGE_KEY)
    },
  },
})
